var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveExploreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 0.625C6.16548 0.625 0.625 6.16548 0.625 13C0.625 19.8345 6.16548 25.375 13 25.375C19.8345 25.375 25.375 19.8345 25.375 13C25.375 6.16548 19.8345 0.625 13 0.625ZM17.0695 8.58931C16.8868 8.52414 16.612 8.61574 16.0624 8.79895L11.0419 10.4724C10.8854 10.5246 10.8071 10.5507 10.7421 10.5952C10.6845 10.6345 10.6348 10.6843 10.5954 10.7418C10.551 10.8068 10.5249 10.8851 10.4727 11.0416L8.7992 16.0621C8.616 16.6117 8.5244 16.8865 8.58956 17.0693C8.64627 17.2283 8.77142 17.3535 8.93045 17.4102C9.1132 17.4753 9.38801 17.3837 9.93762 17.2005L14.9581 15.527C15.1146 15.4749 15.1929 15.4488 15.2579 15.4043C15.3154 15.3649 15.3652 15.3152 15.4046 15.2576C15.449 15.1926 15.4751 15.1144 15.5273 14.9578L17.2008 9.93737C17.384 9.38775 17.4756 9.11294 17.4104 8.93019C17.3537 8.77116 17.2286 8.64602 17.0695 8.58931Z",
    fill: "#F7665F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveExploreIcon);
export default __webpack_public_path__ + "static/media/ActiveExploreIcon.20a6ad1ab030f6c18b44ff82f2c38976.svg";
export { ForwardRef as ReactComponent };